import { render, staticRenderFns } from "./AudioDetails.vue?vue&type=template&id=014f861d&scoped=true"
import script from "./AudioDetails.vue?vue&type=script&lang=js"
export * from "./AudioDetails.vue?vue&type=script&lang=js"
import style0 from "./AudioDetails.vue?vue&type=style&index=0&id=014f861d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014f861d",
  null
  
)

export default component.exports